module.exports = __webpack_public_path__ + "static/background-mobile-f438c5027c859189db54fa707d01e7cd.jpg";